module.exports = __webpack_public_path__ + "static/media/LPSecondRowFirstImg.9b596115.png";